import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate, ICrudGetAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntity } from './job-order.reducer';
import { IJobOrder } from 'app/shared/model/job-order.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IJobOrderDetailProps extends StateProps, DispatchProps, RouteComponentProps<{ id: string }> {}

export const JobOrderDetail = (props: IJobOrderDetailProps) => {
  useEffect(() => {
    props.getEntity(props.match.params.id);
  }, []);

  const { jobOrderEntity } = props;
  return (
    <Row>
      <Col md="8">
        <h2>
          <Translate contentKey="ordersManagementApp.jobOrder.detail.title">JobOrder</Translate> [<b>{jobOrderEntity.id}</b>]
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="jobOrderName">
              <Translate contentKey="ordersManagementApp.jobOrder.jobOrderName">Job Order Name</Translate>
            </span>
          </dt>
          <dd>{jobOrderEntity.jobOrderName}</dd>
          <dt>
            <span id="jobOrderCode">
              <Translate contentKey="ordersManagementApp.jobOrder.jobOrderCode">Job Order Code</Translate>
            </span>
          </dt>
          <dd>{jobOrderEntity.jobOrderCode}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="ordersManagementApp.jobOrder.startDate">Start Date</Translate>
            </span>
          </dt>
          <dd>
            <TextFormat value={jobOrderEntity.startDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
          </dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="ordersManagementApp.jobOrder.endDate">End Date</Translate>
            </span>
          </dt>
          <dd>
            <TextFormat value={jobOrderEntity.endDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
          </dd>
          <dt>
            <Translate contentKey="ordersManagementApp.jobOrder.jobOrderOwner">Job Order Owner</Translate>
          </dt>
          <dd>{jobOrderEntity.jobOrderOwner ? jobOrderEntity.jobOrderOwner.surname  : ''}</dd>
        </dl>
        <Button tag={Link} to="/job-order" replace color="info">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/job-order/${jobOrderEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

const mapStateToProps = ({ jobOrder }: IRootState) => ({
  jobOrderEntity: jobOrder.entity
});

const mapDispatchToProps = { getEntity };

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(JobOrderDetail);
